export const BOOKING_STATUSES = ['new', 'confirmed', 'completed', 'cancelled'] as const;
export type BookingStatus = (typeof BOOKING_STATUSES)[number];

export const ACCOMMODATION_TYPES = [
  'bungalo',
  'vip',
  'terem',
  'cottage',
  'bereg',
] as const;
export type AccommodationType = (typeof ACCOMMODATION_TYPES)[number];

export const ACCOMMODATION_LABELS: Record<AccommodationType, string> = {
  bungalo: 'Дом-Бунгало',
  vip: 'VIP Зона',
  terem: 'Царь-терем',
  cottage: 'Кедровый коттедж номер',
  bereg: 'Номера на берегу',
};

export const PRICE_UNITS = ['night', 'hour', 'guest', 'piece', 'service'] as const;
export type PriceUnit = (typeof PRICE_UNITS)[number];

export const PRICE_PERIODS = ['high_season', 'low_season', 'all_year'] as const;
export type PricePeriod = (typeof PRICE_PERIODS)[number];

export const PRICE_CATEGORIES = [
  // Проживание — 4 колонки на публичных ценах (как в variant-f)
  'accommodation_bungalo',
  'accommodation_terem',
  'accommodation_cottage',
  'accommodation_mix',
  // Доп. услуги — 6 групп
  'extras_bania',
  'extras_fire',
  'extras_cook',
  'extras_play',
  'extras_food',
  'extras_home',
] as const;
export type PriceCategory = (typeof PRICE_CATEGORIES)[number];

export const PRICE_CATEGORY_LABELS: Record<PriceCategory, string> = {
  accommodation_bungalo: 'Дом-Бунгало',
  accommodation_terem: 'Царь-терем',
  accommodation_cottage: 'Кедровый коттедж номер',
  accommodation_mix: 'VIP',
  extras_bania: 'Баня и душ',
  extras_fire: 'Мангал и готовка',
  extras_cook: 'Казаны и посуда',
  extras_play: 'Спорт и игры',
  extras_food: 'Питание',
  extras_home: 'Прочее',
};
